import { Typography } from '@mui/material';

import { AutomationList } from './AutomationList/AutomationList';
import { AutomationModalPaneOptions } from './enums';
import { BlankModal } from 'sharedComponents/Modal';
import { CreateAutomation } from './CreateAutomation/CreateAutomation';
import { ModalPaneContainer } from './styles';
import { ATSAutomationModalTestIds } from 'data-testids/ATS';
import { useAutomation } from './context/AutomationContext';

export const AutomationModal: React.FC = () => {
  const { currentPane, open, onClose } = useAutomation();
  return (
    <BlankModal
      dataTestId={ATSAutomationModalTestIds.MODAL}
      onClose={onClose}
      open={open}
      sx={{ padding: 4, borderRadius: 2 }}
      header={
        <Typography
          data-testid={ATSAutomationModalTestIds.HEADER_TEXT}
          color="black.dark"
          variant="h3"
        >
          Automated Pre-screening
        </Typography>
      }
      body={
        <ModalPaneContainer>
          {currentPane === AutomationModalPaneOptions.CREATE && <CreateAutomation />}
          {currentPane === AutomationModalPaneOptions.LIST && <AutomationList />}
        </ModalPaneContainer>
      }
    />
  );
};
